import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

export const LittleWormChartCont = styled.div`
  display: flex;
  width: 100%;
`;

interface IGroup {
  width: number;
  size: 'tiny' | 'small' | 'normal';
  theme: ITheme;
}

const Group = styled.div<IGroup>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme, width, size }: IGroup) => `
    border: 1px solid ${theme.colors.neutral.primary[0]};
    color: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.nano};
    font-size: ${size === 'tiny' ? '17px' : '20px'};
    font-weight: 700;
    width: ${width}%;
    height: ${
  size === 'tiny'
    ? theme.layout.spacing.decy
    : size === 'small'
      ? '28px'
      : theme.layout.spacing.hekto
};
  `}
`;

export const WeakGroup = styled(Group)`
  ${({ theme }: IGroup) => `
    background: ${theme.colors.support.red[100]};
  `}
`;

export const NormalGroup = styled(Group)`
  ${({ theme }: IGroup) => `
    background: ${theme.colors.accent.blue[100]};
  `}
`;

export const StrongGroup = styled(Group)`
  ${({ theme }: IGroup) => `
    background: ${theme.colors.accent.green[100]};
  `}
`;
